import { USER_HOST } from "config/constants";


export const restAPIs = {


    getEVApps: (language: any, appId: any = null) => ({
        method: 'get',
        endpoint: `${USER_HOST}/json_applications.php?language=${language}${appId ? '&appId=' + appId : ''}`
    }),

    getAppInfo: (appId: any, language: any) => ({
        method: 'get',
        endpoint: `https://www.electronicvillage.org/json_appInfo.php?appId=${appId}&language=${language}`
    }),
    getFounderInfo: (language: any) => ({
        method: 'get',
        endpoint: `https://www.electronicvillage.org/json_founder.php?language=${language}`
    }),
    getEVPages: (language: any, pageId: any) => ({
        method: 'get',
        endpoint: `https://www.electronicvillage.org/json_evPages.php?language=${language}&pageId=${pageId}`
      }),

};
